
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';
import { ChaseOrderStatus } from '../Model/ChaseOrderStatus';
import { GetEnvVarService } from "../../../../service/get-env-var.service";

@Injectable()
export class OrderStatusService {

  private baseUrl: string;

  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
  }

  getTransactionStatusFromUID(uId: string): Observable<ChaseOrderStatus> {
    // debugger;
    return this.http.get(this.baseUrl + `/api/order/getTransactionStatusFromUID/` + uId).pipe(
      map((response: ChaseOrderStatus) => response));
  }
}
